import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminQueryKeys, Admins } from '#api';

export function useDeleteAdminMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (adminID: string) => Admins.deleteAdmin(adminID),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: adminQueryKeys.lists() });
    },
  });
}
